import "./tool"
import React, { Component } from "react";
import ActionPopver from "./ActionPopver";
import ReactEcharts from 'echarts-for-react';
import { Popover, Button } from "antd";
import styles from "./liquidFill.module.less";



const colorGreen = '#78a355'
const colorRed = '#ef4136'
const colorOrange = '#faa755'

const sufName = '剩余电流'

class LiquidFill extends Component {

    state = {
        popVisible: false,
        popKey: 0,
    }

    onSubmit = (data) => {
        const { onActionSubmit } = this.props;
        onActionSubmit && onActionSubmit(data, _ => this.setState({ popVisible: false }))
    }

    renderPopverContent = () => {
        const { filed, data, action, defaultValue, deviceId, loadDefaultValue } = this.props;
        const { MaxThr = {}, AlarmSw = {} } = data || {}
        const max = MaxThr.value;
        const alarmSw = AlarmSw.value;
        return <div>
            <ActionPopver title={filed + sufName} action={action} onSubmit={this.onSubmit} defaultValue={defaultValue}
                loadDefaultValue={loadDefaultValue} deviceId={deviceId} />
        </div>

    }

    render() {
        const { popVisible, popKey } = this.state;
        const { data, filed, bgColor, action } = this.props;
        const { Value = {}, MaxThr = {}, AlarmSw = {}, Status = {} } = data || {}
        const name = Status.value || '';
        const value = (Value || {}).value || 0;

        return (
            <div className={styles.liquidFillMain}>
                <div className={styles.valueDiv}>
                    <div className={styles.state}>
                        {name}
                    </div>
                    <div className={styles.value}>
                        <div className={styles.left}>
                            {value}
                        </div>
                        <div className={styles.right}>
                            {Value.unit}
                        </div>
                    </div>
                </div>
                {action ? <div className={styles.setting}>
                    <Popover key={popKey} trigger="click" visible={popVisible}
                        content={this.renderPopverContent()}
                        onVisibleChange={(popVisible) => this.setState({ popVisible, popKey: popKey + 1 })}>
                        <Button type="primary" className={styles.button}>设置</Button>
                    </Popover>
                </div> : ''}
            </div>
        )
    }
}

export default LiquidFill;